'use strict';

export default function NoItems({
    title,
    description,
    button,
    onClick = undefined,
    link = undefined
}) {
    
    title = title || tMsg('Нет подходящих предложений по вашему запросу');
    description = description || tMsg('Попробуйте изменить параметры поиска или подобрать подходящий вариант из подобранных предложений');
    button = button || tMsg('Искать самолет');
    
    return <div className="el-empty">
        <h3>{title}</h3>
        <p>{description}</p>
        <div className="el-empty__btn">
            {link && <a href={link} className="button button-round2">{button}</a>}
            {!link && <a role="button" className={"button button-round2"} onClick={() => onClick && onClick()}>{button}</a>}
        </div>
    </div>
}